export default __webpack_public_path__ + "static/coming-pc-1021d9d0b05f9197628c73ab87ba18c4.png";